// AUTO-GENERATED by web/scripts/convert-academy.mjs — do not edit by hand.
export interface AcademyModuleMeta {
  slug: string;
  title: string;
  category: string;
  type: 'trading' | 'crypto';
  order: number;
}

export const ACADEMY_MANIFEST: readonly AcademyModuleMeta[] = [
  {
    "slug": "willkommen-und-richtlinien",
    "title": "Willkommen & Richtlinien",
    "category": "📃 Einleitung",
    "type": "trading",
    "order": 1
  },
  {
    "slug": "coaching-buchen",
    "title": "Coaching buchen",
    "category": "📃 Einleitung",
    "type": "trading",
    "order": 2
  },
  {
    "slug": "escape-the-matrix-ebook",
    "title": "Escape the Matrix Ebook",
    "category": "📃 Einleitung",
    "type": "trading",
    "order": 3
  },
  {
    "slug": "links-zu-plattformen",
    "title": "Links zu Plattformen",
    "category": "📃 Einleitung",
    "type": "trading",
    "order": 4
  },
  {
    "slug": "was-ist-fibonacci",
    "title": "Was ist Fibonacci?",
    "category": "🌀 Fibonacci – Das Messwerk der Natur",
    "type": "trading",
    "order": 5
  },
  {
    "slug": "ursprung-wissenschaft-hinter-fibonacci",
    "title": "Ursprung & Wissenschaft Fibonacci",
    "category": "🌀 Fibonacci – Das Messwerk der Natur",
    "type": "trading",
    "order": 6
  },
  {
    "slug": "fibonacci-retracement",
    "title": "Fibonacci Retracement",
    "category": "🌀 Fibonacci – Das Messwerk der Natur",
    "type": "trading",
    "order": 7
  },
  {
    "slug": "fibonacci-extension",
    "title": "Fibonacci Extension",
    "category": "🌀 Fibonacci – Das Messwerk der Natur",
    "type": "trading",
    "order": 8
  },
  {
    "slug": "geldsystem-verstehen",
    "title": "Geldsystem verstehen",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 9
  },
  {
    "slug": "angebot-und-nachfrage",
    "title": "Angebot & Nachfrage",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 10
  },
  {
    "slug": "otc-handel",
    "title": "OTC-Handel",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 11
  },
  {
    "slug": "waehrungspaare",
    "title": "Währungspaare",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 12
  },
  {
    "slug": "was-ist-ein-broker",
    "title": "Was ist ein Broker?",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 13
  },
  {
    "slug": "pips-einfach-erklaert",
    "title": "Pips einfach erklärt",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 14
  },
  {
    "slug": "lots-und-volumen",
    "title": "Lots & Volumen",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 15
  },
  {
    "slug": "stop-loss-und-risiko",
    "title": "Stop-Loss & Risiko",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 16
  },
  {
    "slug": "marktarten-und-ausfuehrungen",
    "title": "Marktarten & Ausführungen",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 17
  },
  {
    "slug": "kerzenkunde",
    "title": "Kerzenkunde",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 18
  },
  {
    "slug": "was-ist-slippage",
    "title": "Was ist Slippage?",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 19
  },
  {
    "slug": "volatilitaet-die-kraft-hinter-der-bewegung",
    "title": "Volatilität",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 20
  },
  {
    "slug": "was-ist-liquiditaet",
    "title": "Was ist Liquidität?",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 21
  },
  {
    "slug": "was-sind-indikatoren-und-warum-wir-sie-nicht-benutzen",
    "title": "Indikatoren & warum wir sie nicht nutzen",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 22
  },
  {
    "slug": "hebel-verstehen",
    "title": "Hebel verstehen",
    "category": "📘 Trading-Grundlagen",
    "type": "trading",
    "order": 23
  },
  {
    "slug": "was-sind-futures",
    "title": "Was sind Futures?",
    "category": "💻 Futures-Grundlagen",
    "type": "trading",
    "order": 24
  },
  {
    "slug": "wie-funktionieren-long-short",
    "title": "Long & Short",
    "category": "💻 Futures-Grundlagen",
    "type": "trading",
    "order": 25
  },
  {
    "slug": "was-ist-leverage-hebel",
    "title": "Was ist Leverage/Hebel?",
    "category": "💻 Futures-Grundlagen",
    "type": "trading",
    "order": 26
  },
  {
    "slug": "liquidation-erklaert",
    "title": "Liquidation erklärt",
    "category": "💻 Futures-Grundlagen",
    "type": "trading",
    "order": 27
  },
  {
    "slug": "was-bedeutet-verfall-bei-krypto-futures",
    "title": "Verfall bei Futures",
    "category": "💻 Futures-Grundlagen",
    "type": "trading",
    "order": 28
  },
  {
    "slug": "woher-kommt-der-futures-preis",
    "title": "Woher kommt der Futures-Preis?",
    "category": "🖥️ Plattform-Verständnis & Ordertypen",
    "type": "trading",
    "order": 29
  },
  {
    "slug": "funding-rate",
    "title": "Funding Rate",
    "category": "🖥️ Plattform-Verständnis & Ordertypen",
    "type": "trading",
    "order": 30
  },
  {
    "slug": "orderarten-market-limit-stop-limit-tpsl",
    "title": "Orderarten",
    "category": "🖥️ Plattform-Verständnis & Ordertypen",
    "type": "trading",
    "order": 31
  },
  {
    "slug": "cross-vs-isolated-margin-was-passt-wann",
    "title": "Cross vs Isolated Margin",
    "category": "🖥️ Plattform-Verständnis & Ordertypen",
    "type": "trading",
    "order": 32
  },
  {
    "slug": "unterschied-btcusdt-vs-btcusd-vs-btcusd0331",
    "title": "BTCUSDT vs BTCUSD vs BTCUSD0331",
    "category": "🖥️ Plattform-Verständnis & Ordertypen",
    "type": "trading",
    "order": 33
  },
  {
    "slug": "tag-1-als-trader",
    "title": "Tag 1 als Trader",
    "category": "🗓️ Tag 1 als Trader",
    "type": "trading",
    "order": 34
  },
  {
    "slug": "plattformen-und-tools",
    "title": "Plattformen & Tools",
    "category": "🗓️ Tag 1 als Trader",
    "type": "trading",
    "order": 35
  },
  {
    "slug": "zeiteinheiten-und-blash",
    "title": "Zeiteinheiten & BLASH",
    "category": "🗓️ Tag 1 als Trader",
    "type": "trading",
    "order": 36
  },
  {
    "slug": "tradingtypen-und-strategien",
    "title": "Trading-Typen & Strategien",
    "category": "🗓️ Tag 1 als Trader",
    "type": "trading",
    "order": 37
  },
  {
    "slug": "wie-analysiere-ich",
    "title": "Wie analysiere ich?",
    "category": "🗓️ Tag 1 als Trader",
    "type": "trading",
    "order": 38
  },
  {
    "slug": "tradingtagebuch",
    "title": "Trading-Tagebuch",
    "category": "🗓️ Tag 1 als Trader",
    "type": "trading",
    "order": 39
  },
  {
    "slug": "trading-ziele",
    "title": "Trading-Ziele",
    "category": "🗓️ Tag 1 als Trader",
    "type": "trading",
    "order": 40
  },
  {
    "slug": "wachstumsstrategie-kontowachstum",
    "title": "Wachstumsstrategie",
    "category": "🗓️ Tag 1 als Trader",
    "type": "trading",
    "order": 41
  },
  {
    "slug": "marktstruktur-lesen-hoch-tief-trendwechsel",
    "title": "Marktstruktur lesen",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 42
  },
  {
    "slug": "golden-pocket-fibs-supportresistance",
    "title": "Golden Pocket & Fibs",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 43
  },
  {
    "slug": "breakout-setup-vs-pullback-entry",
    "title": "Breakout vs Pullback Entry",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 44
  },
  {
    "slug": "tp-logik-wo-macht-teilverkauf-sinn",
    "title": "TP-Logik & Teilverkäufe",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 45
  },
  {
    "slug": "einstieg-planen-mit-sltp-im-voraus",
    "title": "Einstieg planen mit SL/TP",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 46
  },
  {
    "slug": "wiederholbare-setups-erkennen",
    "title": "Wiederholbare Setups erkennen",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 47
  },
  {
    "slug": "wann-ist-ein-entry-gueltig",
    "title": "Wann ist ein Entry gültig?",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 48
  },
  {
    "slug": "entry-nach-ruecklauf-nicht-im-move",
    "title": "Entry nach Rücklauf",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 49
  },
  {
    "slug": "candle-reaktionen-verstehen",
    "title": "Candle-Reaktionen",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 50
  },
  {
    "slug": "bestaetigung-oder-impuls",
    "title": "Bestätigung oder Impuls",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 51
  },
  {
    "slug": "wann-kein-entry-erlaubt-ist",
    "title": "Wann kein Entry erlaubt ist",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 52
  },
  {
    "slug": "checkliste-fuer-entrys",
    "title": "Checkliste für Entrys",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 53
  },
  {
    "slug": "entry-fehler-anfaenger",
    "title": "Entry-Fehler Anfänger",
    "category": "🎯 Strukturbasierte Tradeplanung",
    "type": "trading",
    "order": 54
  },
  {
    "slug": "wie-berechne-ich-meine-positionsgroesse",
    "title": "Positionsgröße berechnen",
    "category": "💰 Positionsgröße & Risikomanagement",
    "type": "trading",
    "order": 55
  },
  {
    "slug": "sltp-in-prozent-und-dollar",
    "title": "SL/TP in % und Dollar",
    "category": "💰 Positionsgröße & Risikomanagement",
    "type": "trading",
    "order": 56
  },
  {
    "slug": "hebel-nicht-als-waffe-sondern-werkzeug",
    "title": "Hebel als Werkzeug",
    "category": "💰 Positionsgröße & Risikomanagement",
    "type": "trading",
    "order": 57
  },
  {
    "slug": "psychologische-reue-vermeiden",
    "title": "Psychologische Reue vermeiden",
    "category": "💰 Positionsgröße & Risikomanagement",
    "type": "trading",
    "order": 58
  },
  {
    "slug": "funding-rate-was-sie-ueber-den-markt-verraet",
    "title": "Funding Rate & Markt",
    "category": "📊 Sentiment, Funding & Liquidationen",
    "type": "trading",
    "order": 59
  },
  {
    "slug": "liquidation-maps-hyblock-coinalyze",
    "title": "Liquidation Maps (Hyblock)",
    "category": "📊 Sentiment, Funding & Liquidationen",
    "type": "trading",
    "order": 60
  },
  {
    "slug": "open-interest-preisverhalten",
    "title": "Open Interest & Preis",
    "category": "📊 Sentiment, Funding & Liquidationen",
    "type": "trading",
    "order": 61
  },
  {
    "slug": "was-tun-bei-extremem-sentiment",
    "title": "Extremes Sentiment",
    "category": "📊 Sentiment, Funding & Liquidationen",
    "type": "trading",
    "order": 62
  },
  {
    "slug": "liquiditaet-jagen-was-machen-die-big-boys",
    "title": "Liquidität jagen (Big Boys)",
    "category": "📊 Sentiment, Funding & Liquidationen",
    "type": "trading",
    "order": 63
  },
  {
    "slug": "reentry-strategie",
    "title": "Re-Entry Strategie",
    "category": "🧩 Fortgeschrittene Strategien & Praxis",
    "type": "trading",
    "order": 64
  },
  {
    "slug": "teilverkaeufe-position-splitting",
    "title": "Teilverkäufe & Position Splitting",
    "category": "🧩 Fortgeschrittene Strategien & Praxis",
    "type": "trading",
    "order": 65
  },
  {
    "slug": "korrekturtrading-nachkaufzonen-gezielt-nutzen",
    "title": "Korrekturtrading & Nachkaufzonen",
    "category": "🧩 Fortgeschrittene Strategien & Praxis",
    "type": "trading",
    "order": 66
  },
  {
    "slug": "swing-vs-intraday-futures",
    "title": "Swing vs Intraday Futures",
    "category": "🧩 Fortgeschrittene Strategien & Praxis",
    "type": "trading",
    "order": 67
  },
  {
    "slug": "rollover-bei-quartalskontrakten",
    "title": "Rollover Quartalskontrakten",
    "category": "🧩 Fortgeschrittene Strategien & Praxis",
    "type": "trading",
    "order": 68
  },
  {
    "slug": "hedging-positionen-absichern",
    "title": "Hedging",
    "category": "🧩 Fortgeschrittene Strategien & Praxis",
    "type": "trading",
    "order": 69
  },
  {
    "slug": "typische-fehler-im-futures-handel-gier-panik-revenge",
    "title": "Gier / Panik / Revenge",
    "category": "🧠 Psychologie im Futures-Trading",
    "type": "trading",
    "order": 70
  },
  {
    "slug": "ungeduld-reue-als-zerstoerer",
    "title": "Ungeduld & Reue",
    "category": "🧠 Psychologie im Futures-Trading",
    "type": "trading",
    "order": 71
  },
  {
    "slug": "trade-setup-vs-live-impuls-wie-du-stabil-bleibst",
    "title": "Setup vs Live-Impuls",
    "category": "🧠 Psychologie im Futures-Trading",
    "type": "trading",
    "order": 72
  },
  {
    "slug": "worst-case-simulation-was-wenn-du-3x-verlierst",
    "title": "Worst-Case Simulation",
    "category": "🧠 Psychologie im Futures-Trading",
    "type": "trading",
    "order": 73
  },
  {
    "slug": "journaling-reflexionsroutinen",
    "title": "Journaling & Reflexion",
    "category": "🧠 Psychologie im Futures-Trading",
    "type": "trading",
    "order": 74
  },
  {
    "slug": "trading-tagebuch-als-vorlage",
    "title": "Trading-Tagebuch Vorlage",
    "category": "🧠 Psychologie im Futures-Trading",
    "type": "trading",
    "order": 75
  },
  {
    "slug": "blockchain-basics",
    "title": "Blockchain Basics",
    "category": "🧱 Blockchain & Grundlagen",
    "type": "crypto",
    "order": 1
  },
  {
    "slug": "wallets-und-sicherheit",
    "title": "Wallets & Sicherheit",
    "category": "🧱 Blockchain & Grundlagen",
    "type": "crypto",
    "order": 2
  },
  {
    "slug": "boersen-und-exchanges",
    "title": "Börsen & Exchanges",
    "category": "🧱 Blockchain & Grundlagen",
    "type": "crypto",
    "order": 3
  },
  {
    "slug": "sicherheit-und-scams",
    "title": "Sicherheit & Scams",
    "category": "🧱 Blockchain & Grundlagen",
    "type": "crypto",
    "order": 4
  },
  {
    "slug": "krypto-begriffe",
    "title": "Krypto-Begriffe",
    "category": "🧱 Blockchain & Grundlagen",
    "type": "crypto",
    "order": 5
  },
  {
    "slug": "defi-einfuehrung",
    "title": "DeFi Einführung",
    "category": "💎 DeFi & Passive Income",
    "type": "crypto",
    "order": 6
  },
  {
    "slug": "staking-grundlagen",
    "title": "Staking Grundlagen",
    "category": "💎 DeFi & Passive Income",
    "type": "crypto",
    "order": 7
  },
  {
    "slug": "liquidity-pools",
    "title": "Liquidity Pools",
    "category": "💎 DeFi & Passive Income",
    "type": "crypto",
    "order": 8
  },
  {
    "slug": "yield-farming",
    "title": "Yield Farming",
    "category": "💎 DeFi & Passive Income",
    "type": "crypto",
    "order": 9
  },
  {
    "slug": "lending-borrowing",
    "title": "Lending & Borrowing",
    "category": "💎 DeFi & Passive Income",
    "type": "crypto",
    "order": 10
  },
  {
    "slug": "stablecoins-income",
    "title": "Stablecoins Income",
    "category": "💎 DeFi & Passive Income",
    "type": "crypto",
    "order": 11
  },
  {
    "slug": "passive-income",
    "title": "Passive Income",
    "category": "💎 DeFi & Passive Income",
    "type": "crypto",
    "order": 12
  },
  {
    "slug": "chart-analyse-basics",
    "title": "Chart-Analyse Basics",
    "category": "📈 Trading & Analyse",
    "type": "crypto",
    "order": 15
  },
  {
    "slug": "technische-analyse",
    "title": "Technische Analyse",
    "category": "📈 Trading & Analyse",
    "type": "crypto",
    "order": 16
  },
  {
    "slug": "altcoin-analyse",
    "title": "Altcoin-Analyse",
    "category": "📈 Trading & Analyse",
    "type": "crypto",
    "order": 17
  },
  {
    "slug": "spot-vs-futures",
    "title": "Spot vs Futures",
    "category": "📈 Trading & Analyse",
    "type": "crypto",
    "order": 18
  },
  {
    "slug": "order-arten",
    "title": "Order-Arten",
    "category": "📈 Trading & Analyse",
    "type": "crypto",
    "order": 19
  },
  {
    "slug": "risiko-management",
    "title": "Risiko-Management",
    "category": "📈 Trading & Analyse",
    "type": "crypto",
    "order": 20
  },
  {
    "slug": "trading-psychologie",
    "title": "Trading-Psychologie",
    "category": "📈 Trading & Analyse",
    "type": "crypto",
    "order": 21
  },
  {
    "slug": "trading-apps-tools",
    "title": "Trading Apps & Tools",
    "category": "🛠️ Tools & Apps",
    "type": "crypto",
    "order": 22
  },
  {
    "slug": "schnelle-updates",
    "title": "Schnelle Updates",
    "category": "🛠️ Tools & Apps",
    "type": "crypto",
    "order": 23
  },
  {
    "slug": "regeln-und-info",
    "title": "Regeln & Info",
    "category": "ℹ️ Info & Support",
    "type": "crypto",
    "order": 24
  },
  {
    "slug": "zugang-zur-upro-capital-academy",
    "title": "Zugang zur UPRO Capital Academy",
    "category": "ℹ️ Info & Support",
    "type": "crypto",
    "order": 25
  }
] as const;
